import { SEO_SERVICE, type SeoService } from './core';

const TITLE_BRAND = 'אליאור מור';

const SERVICE_TITLE_COPY: Record<
  SeoService,
  {
    globalPrimary: string;
    globalSecondary: string;
    localPrimary: string;
    localSecondary: string;
  }
> = {
  [SEO_SERVICE.wedding]: {
    globalPrimary: 'די ג׳יי לחתונה',
    globalSecondary: 'תקליטן מומלץ לחתונה',
    localPrimary: 'די ג׳יי לחתונה',
    localSecondary: 'תקליטן מומלץ לחתונה',
  },
  [SEO_SERVICE.henna]: {
    globalPrimary: 'די ג׳יי לחינה',
    globalSecondary: 'תקליטן מומלץ לחינה',
    localPrimary: 'די ג׳יי לחינה',
    localSecondary: 'תקליטן מומלץ לחינה',
  },
  [SEO_SERVICE.barBat]: {
    globalPrimary: 'די ג׳יי לבר/בת מצווה',
    globalSecondary: 'תקליטן מומלץ לבר/בת מצווה',
    localPrimary: 'די ג׳יי לבר/בת מצווה',
    localSecondary: 'תקליטן מומלץ לבר/בת מצווה',
  },
  [SEO_SERVICE.event]: {
    globalPrimary: 'דיג׳יי לאירוע',
    globalSecondary: 'תקליטן מומלץ לאירועים',
    localPrimary: 'די ג׳יי לאירוע',
    localSecondary: 'תקליטן מומלץ לאירועים',
  },
};

function withBrand(primary: string) {
  return `${primary} - ${TITLE_BRAND}`;
}

export function buildGlobalSeoTitle(service: SeoService) {
  const copy = SERVICE_TITLE_COPY[service];
  if (service === SEO_SERVICE.event) {
    return `${copy.globalPrimary.replace(/דיג׳יי/g, 'די ג׳יי')} | תקליטן לאירועים - ${TITLE_BRAND}`;
  }
  if (service === SEO_SERVICE.wedding) {
    return 'די ג׳יי לחתונה | תקליטן מומלץ לחתונות - אליאור מור';
  }
  if (service === SEO_SERVICE.henna) {
    return 'די ג׳יי לחינה | תקליטן מומלץ לחינות - אליאור מור';
  }
  if (service === SEO_SERVICE.barBat) {
    return 'די ג׳יי לבר/בת מצווה | תקליטן מומלץ לבר ובת מצווה - אליאור מור';
  }
  return withBrand(copy.globalPrimary.replace(/דיג׳יי/g, 'די ג׳יי'));
}

export function buildLocalSeoTitle(service: SeoService, locationLabel: string) {
  const copy = SERVICE_TITLE_COPY[service];
  const loc = String(locationLabel || '').trim();
  const localPrimary = loc ? `${copy.localPrimary} ב${loc}` : copy.localPrimary;
  if (service === SEO_SERVICE.event) {
    const eventPrimary = loc ? `די ג׳יי ב${loc}` : copy.localPrimary;
    const localSecondary = loc ? `תקליטן לאירוע ב${loc}` : 'תקליטן לאירועים';
    return `${eventPrimary.replace(/דיג׳יי/g, 'די ג׳יי')} | ${localSecondary} - ${TITLE_BRAND}`;
  }
  if (
    service === SEO_SERVICE.wedding ||
    service === SEO_SERVICE.henna ||
    service === SEO_SERVICE.barBat
  ) {
    return `${localPrimary.replace(/דיג׳יי/g, 'די ג׳יי')} - ${TITLE_BRAND}`;
  }
  return withBrand(localPrimary.replace(/דיג׳יי/g, 'די ג׳יי'));
}

export const HOME_SEO_TITLE =
  'די ג׳יי אליאור מור | מוזיקה לאירועים';
